export default "__VITE_ASSET__88dbad9b__"